export const mapExtentProjected = Object.freeze({
  north: 85.0511288,
  south: -85.0511287,
  east: 180.0,
  west: -180.0
});
export const mapSides = Object.freeze({
  left: "left",
  right: "right"
});
export const degreeEqualsTolerance = 1e-9;
export const degreeNearlyEqualsTolerance = 1e-6;
export const earthRadius = 6378137.0;
export const tileSize = 256;
export const iconColorDefault = "#7d003f";
export const iconSizeDefault = 21;
export const iconPinHeightDefault = 30;
export const breakSizeDefault = 600;
export const contextPath = "/api/maps";
export const apiPath = "/v2";
export const defaultProxyPath = "/api/maps-proxy";
export const clientHeader = "X-Maps-Client";
export const versionHeader = "X-Maps-Version";
export const prefixHeader = "X-Forwarded-Prefix";